import { useRef, useState } from "react";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";

import styles from "./DataSources.module.scss";

// import { ReactComponent as Dataverse } from "../../../../assets/icons/dataverse-icon.svg";
import { ReactComponent as Exel } from "../../../../assets/icons/exel-icon.svg";
import { ReactComponent as MSPlanner } from "../../../../assets/icons/msplanner2024-icon.svg";
import { PATHS } from "../../../../constants/PATHS";
import { useClickOutside } from "../../../../hooks/useClickOutside";
import { useAppDispatch } from "../../../../store/hooks/hooks";
import {
  setTemplateSPage,
  setTemplateStep,
} from "../../../../store/slices/stepSlice";
import { setDemo } from "../../../../store/slices/uploadFileSlice";
import { ETemplatePage, ETemplateStep } from "../../../../types/steps";
import { Auth } from "../../../Auth";
import { ReactPortal } from "../../../ReactPortal";
import { ReactPortalSubstrate } from "../../../ReactPortalSubstrate";
import { Title } from "../../../Title";
import { DataSourcesItem } from "../DataSourcesItem";

export const DataSources = () => {
  const navigate = useNavigate();
  const [isPortalOpen, seIsPortalOpen] = useState(false);

  const [token] = useCookies(["accessToken"]);

  const dispatch = useAppDispatch();

  const handelClick = () => {
    dispatch(setTemplateSPage(ETemplatePage.SelectTemplatePage));
    dispatch(setTemplateStep(ETemplateStep.step2));
    if (token.accessToken) {
      dispatch(setDemo("demo"));
    }
  };

  const formRef = useRef<HTMLDivElement>(null);

  const onOpenClick = () => {
    if (token.accessToken) {
      dispatch(setTemplateSPage(ETemplatePage.SelectTemplatePage));
      dispatch(setTemplateStep(ETemplateStep.step2));
      dispatch(setDemo("upload"));
    }
    seIsPortalOpen(true);
  };

  const onCloseClick = () => {
    seIsPortalOpen(false);
  };

  // const onDataverseClick = () => {
  //   if (!token.accessToken) {
  //     seIsPortalOpen(true);
  //   } else {
  //     navigate(PATHS.DATAVERSE);
  //   }
  // };

  const onMSPlannerClick = () => {
    if (!token.accessToken) {
      seIsPortalOpen(true);
    } else {
      navigate(PATHS.MSPLANNER);
    }
  };

  useClickOutside(formRef, onCloseClick);

  return (
    <div className={styles.root}>
      <Title tagName={"h4"}>Available Data Sources</Title>
      <div className={styles.wrapper}>
        {/* <DataSourcesItem
          onClick={onDataverseClick}
          icon={<Dataverse />}
          title={"Dataverse"}
          className={styles.item}
        /> */}
        <DataSourcesItem
          onClick={onMSPlannerClick}
          icon={<MSPlanner />}
          title={"Planner"}
          className={styles.item}
        />
        <DataSourcesItem
          onClick={onOpenClick}
          icon={<Exel />}
          title={"Upload your Data"}
          className={styles.item}
        />
        <DataSourcesItem
          onClick={handelClick}
          icon={<Exel />}
          title={"Demo Data"}
          mark={true}
          className={styles.item}
        />
      </div>
      {isPortalOpen && (
        <ReactPortal>
          <ReactPortalSubstrate className={styles.portalWrapper}>
            <Auth ref={formRef} onClose={onCloseClick} />
          </ReactPortalSubstrate>
        </ReactPortal>
      )}
    </div>
  );
};
